import { MyAccountTypes } from './types';

export const getInfoUser = (user_id: number) => ({
  types: [
    MyAccountTypes.GET_INFO_USER_REQUEST,
    MyAccountTypes.GET_INFO_USER_SUCCESS,
    MyAccountTypes.GET_INFO_USER_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/boletim_web/minha_conta/get_user_info`, {
      params: { user_id },
    }),
});

export const infoEditUser = (id: number) => ({
  types: [
    MyAccountTypes.GET_EDIT_USER_REQUEST,
    MyAccountTypes.GET_EDIT_USER_SUCCESS,
    MyAccountTypes.GET_EDIT_USER_FAILURE,
  ],
  promise: (client: any) => client.get(`/boletim_web/minha_conta/get_user_id/${id}`),
});

export const createUserPreference = (preferenceId: number) => {
  const data = {
    preference_id: preferenceId,
  };
  return {
    types: [
      MyAccountTypes.CREATE_USER_PREFERENCES_REQUEST,
      MyAccountTypes.CREATE_USER_PREFERENCES_SUCCESS,
      MyAccountTypes.CREATE_USER_PREFERENCES_FAILURE,
    ],
    preferenceId,
    promise: (client: any) => client.post('/boletim_web/minha_conta/user_preferences', data),
  };
};

export const destroyUserPreference = (preferenceId: number) => ({
  types: [
    MyAccountTypes.DESTROY_USER_PREFERENCES_REQUEST,
    MyAccountTypes.DESTROY_USER_PREFERENCES_SUCCESS,
    MyAccountTypes.DESTROY_USER_PREFERENCES_FAILURE,
  ],
  promise: (client: any) =>
    client.delete(`/boletim_web/minha_conta/user_preferences`, {
      params: { preference_id: preferenceId },
    }),
});

export const getUsers = () => ({
  types: [
    MyAccountTypes.GET_USERS_REQUEST,
    MyAccountTypes.GET_USERS_SUCCESS,
    MyAccountTypes.GET_USERS_FAILURE,
  ],
  promise: (client: any) => client.get(`/boletim_web/minha_conta/get_users_client`),
});

export const current_sale = () => ({
  types: [
    MyAccountTypes.GET_CURRENT_SALE_REQUEST,
    MyAccountTypes.GET_CURRENT_SALE_SUCCESS,
    MyAccountTypes.GET_CURRENT_SALE_FAILURE,
  ],
  promise: (client: any) => client.get(`/api/controle_crm/current_sale`),
});

export const get_scheduled_sale = () => ({
  types: [
    MyAccountTypes.GET_SCHEDULED_SALE_REQUEST,
    MyAccountTypes.GET_SCHEDULED_SALE_SUCCESS,
    MyAccountTypes.GET_SCHEDULED_SALE_FAILURE,
  ],
  promise: (client: any) => client.get(`/api/controle_crm/scheduled_sale`),
});

export const has_pending_incomes = (saleId: number) => ({
  types: [
    MyAccountTypes.GET_PENDING_INCOMES_REQUEST,
    MyAccountTypes.GET_PENDING_INCOMES_SUCCESS,
    MyAccountTypes.GET_PENDING_INCOMES_FAILURE,
  ],
  promise: (client: any) => client.get(`/api/controle_crm/has_pending_incomes/${saleId}`),
});

export const getIncomes = (saleId: number) => ({
  types: [
    MyAccountTypes.GET_INCOMES_REQUEST,
    MyAccountTypes.GET_INCOMES_SUCCESS,
    MyAccountTypes.GET_INCOMES_FAILURE,
  ],
  promise: (client: any) =>
    client.get(`/api/controle_crm/incomes.json`, {
      params: { sale_id: saleId },
    }),
});

export const solicitation_edition_email = (params: object) => ({
  types: [
    MyAccountTypes.GET_SOLICITATION_EDITION_REQUEST,
    MyAccountTypes.GET_SOLICITATION_EDITION_SUCCESS,
    MyAccountTypes.GET_SOLICITATION_EDITION_FAILURE,
  ],
  promise: (client: any) => client.post('/solicitation_alteration', params),
});

export const solicitation_addition_email = (params: object) => ({
  types: [
    MyAccountTypes.GET_SOLICITATION_ADDITION_REQUEST,
    MyAccountTypes.GET_SOLICITATION_ADDITION_SUCCESS,
    MyAccountTypes.GET_SOLICITATION_ADDITION_FAILURE,
  ],
  promise: (client: any) => client.post('/solicitation_addition', params),
});

export const request_list = () => ({
  types: [
    MyAccountTypes.GET_SOLICITATION_LIST_REQUEST,
    MyAccountTypes.GET_SOLICITATION_LIST_SUCCESS,
    MyAccountTypes.GET_SOLICITATION_LIST_FAILURE,
  ],
  promise: (client: any) => client.get(`/boletim_web/minha_conta/request_list`),
});

export const my_filters = () => ({
  types: [
    MyAccountTypes.GET_MY_FILTERS_REQUEST,
    MyAccountTypes.GET_MY_FILTERS_SUCCESS,
    MyAccountTypes.GET_MY_FILTERS_FAILURE,
  ],
  promise: (client: any) => client.get(`/boletim_web/minha_conta/meus_filtros`),
});

export const boletos_online = () => ({
  types: [
    MyAccountTypes.GET_BOLETOS_ONLINE_REQUEST,
    MyAccountTypes.GET_BOLETOS_ONLINE_SUCCESS,
    MyAccountTypes.GET_BOLETOS_ONLINE_FAILURE,
  ],
  promise: (client: any) => client.get(`/boletim_web/minha_conta/boletos_online_new`),
});

export const update_shortcuts = (selected_services_ids: Array<number>) => ({
  types: [
    MyAccountTypes.GET_UPDATE_SHORTCUTS_REQUEST,
    MyAccountTypes.GET_UPDATE_SHORTCUTS_SUCCESS,
    MyAccountTypes.GET_UPDATE_SHORTCUTS_FAILURE,
  ],
  promise: (client: any) =>
    client.post('/boletim_web/minha_conta/update_shortcuts', { selected_services_ids }),
});
